"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _InputDate = require("./InputDate.styles");

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

var _es = _interopRequireDefault(require("date-fns/locale/es"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(0, _reactDatepicker.registerLocale)('es', _es["default"]);

var InputDate = function InputDate(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'full' : _ref$size,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      inputRef = _ref.inputRef,
      action = _ref.action,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-input-date' : _ref$dataTestId,
      defaultDate = _ref.defaultDate,
      _ref$maxDate = _ref.maxDate,
      maxDate = _ref$maxDate === void 0 ? null : _ref$maxDate;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var _useState = (0, _react.useState)(defaultDate),
      _useState2 = _slicedToArray(_useState, 2),
      date = _useState2[0],
      setDate = _useState2[1];

  (0, _react.useEffect)(function () {
    return setDate(defaultDate);
  }, [defaultDate]);

  var handleAction = function handleAction(event) {
    setDate(event);
    if (typeof action === 'function') action(event);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_InputDate.Occ__InputContainer, {
    size: size,
    ref: inputRef,
    "data-test-id": dataTestId
  }, /*#__PURE__*/_react["default"].createElement(_InputDate.Occ_Label, {
    color: color
  }, label), /*#__PURE__*/_react["default"].createElement(_InputDate.Occ_InputDate, {
    size: size,
    color: color
  }, /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
    onChange: function onChange(e) {
      return handleAction(e);
    },
    selected: date ? new Date(date) : null,
    placeholderText: "dd-mm-aaaa",
    showYearDropdown: true,
    dateFormatCalendar: "MMMM",
    dateFormat: 'dd-MM-yyyy',
    scrollableYearDropdown: true,
    yearDropdownItemNumber: 60,
    locale: "es",
    maxDate: maxDate !== null && maxDate !== void 0 ? maxDate : null
  }))));
};

var _default = InputDate;
exports["default"] = _default;